module.exports = __webpack_public_path__ + "static/media/search.01de42ee.svg";